import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportSectionsType, useMoveReportSectionUpAndDownMutation } from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
}

export const ReportSectionActionMenuReorder: React.FC<Props> = ({ section }) => {
  const { report, reportQuery } = useReport();
  const { mutate: moveSectionMutate } = useMoveReportSectionUpAndDownMutation({
    onSuccess: async (data) => {
      if (data.moveReportSectionUpAndDown?.status) {
        await reportQuery.refetch();
      } else if (data.moveReportSectionUpAndDown?.status === false) {
        notifyError(data.moveReportSectionUpAndDown?.message ?? "Error moving section in the specified direction");
      }
    },
    onError: (error) => {
      console.error("Error while moving section:", error);
      notifyError("Error Moving Section");
    },
  });

  const move = (moveUp: boolean) =>
    moveSectionMutate({ reportId: report.id, sectionId: section.id, moveUp, pageLocation: section.pageLocation });

  return (
    <>
      <DropdownMenuItem onClick={() => move(true)}>
        <ArrowUpIcon />
        Move Up
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => move(false)}>
        <ArrowDownIcon />
        Move Down
      </DropdownMenuItem>
    </>
  );
};
